// import {
//   Component, Input, OnDestroy, OnInit,
//
// } from '@angular/core';
import {Subject} from 'rxjs';
import {Store} from '@ngrx/store';
import {InboxState} from '../../store/reducers/inbox.reducers';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from '@core/services/snack-bar.service';
import {FileManagementService} from '@core/services/file-management.service';
import {DownloadFileCommand} from '../../commands/inbox.command';
import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {Component, Input, OnDestroy, OnInit} from '@angular/core';

@Component({
    standalone: false,
    selector: 'particle-mail-thread-single-content',
  templateUrl: './mail-thread-single-content.component.html',
  styleUrls: ['./mail-thread-single-content.component.scss']
})
export class MailThreadSingleContentComponent implements OnInit, OnDestroy {
  @Input() item: any;
  message: string;
  private unSubscribe$ = new Subject<void>();
  constructor(private store: Store<InboxState>,
              private commandService: CommandService,
              protected snackBarService: SnackBarService,
              public fileManagementService: FileManagementService,
         ) {
  }

  ngOnInit( ) {
    this.message = this.item.transformedMessage;
    if (this.message) {
      if (this.item.fieldValues.ContentUrl) {
        this.message = this.message.replace('[ContentUrl]', this.item.fieldValues.ContentUrl);
      }
      this.message = this.message.replace(new RegExp('{{ITP_ROOT}}/', 'g'), '');
    }
  }
  discardMsg(event) {
    this.item.IsShowReply = false;
  }
  downloadAttachment(attachment: any) {
    this.executeDownloadFileCommand(attachment.attachmentId);
  }
  private executeDownloadFileCommand(fileEntryId: any) {
    const downloadFileCommand = new DownloadFileCommand(fileEntryId, '');
    this.commandService.executeCommand(downloadFileCommand).pipe().subscribe(data => {
      console.log('Download File', data);
      this.fileManagementService.downloadOneTimeSignedUrl(data.Payload['DownloadUrl'], data.Payload['FileName']);
    });
  }
  ngOnDestroy (): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

}
